<template>
  <FilterButton :title="title" @close="save" @clear="clear" :data-test="`filter-btn-activator-${displayName}`">
    <template #menu="{ close }">
      <div class="menu">
        <h4>All {{ displayName }}</h4>
        <div class="scroll-list" v-if="!secondSet">
          <label v-for="item in items" :key="item">
            <input type="checkbox" v-model="selected" :value="item" :data-test="`filter-item-carrier-checkbox-${item}`" />
            <span>{{ item }}</span>
          </label>
        </div>
        <div class="dbl-container" v-else>
          <div class="scroll-list-dbl">
            <div v-for="item in items" :key="item">
              <label>
                <input type="checkbox" v-model="selected" :value="item"
                  :data-test="`filter-item-carrier-checkbox-${item}`" />
                <span class="pl-2 pr-2">{{ item }}</span>
              </label>
            </div>
          </div>
          <div class="scroll-list-dbl">
            <div v-for="item in secondSet" :key="item">
              <label>
                <input type="checkbox" v-model="selected" :value="item"
                  :data-test="`filter-item-carrier-checkbox-${item}`" />
                <span class="pl-2 pr-2">{{ item }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="buttons">
          <v-btn size="small" variant="outlined" @click="clear" data-test="filter-carrier-size-clear">Clear</v-btn>
          <span>
            <v-btn class="mr8" variant="flat" size="small" color="secondary" @click="selectAll"
              data-test="filter-carrier-size-select-all">Select All</v-btn>
            <v-btn size="small" variant="flat" color="primary" @click="() => { close() }"
              data-test="filter-carrier-size-apply">Apply</v-btn>
          </span>
        </div>
      </div>
    </template>
  </FilterButton>
</template>

<script>
import FilterButton from '@/components/FilterButton';

export default {
  name: 'CarrierAttributeFilter',
  components: { FilterButton },
  props: {
    modelValue: Array,
    items: Array,
    displayName: String,
    secondSet: { type: Array, required: false }
  },
  data() {
    return {
      dirty: false,
      selected: []
    };
  },
  computed: {
    title() {
      if (this.selected.length === 1) {
        return this.selected[0];
      }
      return this.displayName;
    }
  },
  methods: {
    clear() {
      this.selected = [];
    },
    save() {
      if (this.dirty) {
        this.dirty = false;
        this.$emit('update:modelValue', this.selected);
        this.$emit('change');
      }
      return true;
    },
    selectAll() {
      this.selected = this.items.map(x => x);
    }
  },
  watch: {
    selected() {
      this.dirty = true;
      this.$emit('input', this.selected);
    }
  }
};

</script>

<style scoped>
.mr8 {
  margin-right: 8px;
}

.menu {
  padding: 1rem 0 0 0;
  min-width: 500px;
  border: 1px solid var(--v-border-base);
}

.menu>h4 {
  padding: 0 1rem;
}

.dbl-container {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid var(--v-border-base);
  padding: 0.5rem;
  margin: 0.5rem 1rem 1rem;
}

.scroll-list-dbl {
  overflow-y: auto;
  width: 50%;
}

.scroll-list-dbl>label {
  padding: 0.2rem 0;
  cursor: pointer;
}

.scroll-list {
  max-height: 300px;
  overflow-y: auto;
  margin: 0.5rem 1rem 1rem;
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-column-gap: 4rem;
  border: 1px solid var(--v-border-base);
  padding: 0.5rem;
}

.scroll-list>label {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
  align-items: center;
  align-content: center;
  padding: 0.2rem 0;
  cursor: pointer;
  user-select: none;
}

.menu>.buttons {
  padding: 1rem;
  border-top: 1px solid var(--v-border-base);
  background: var(--v-gray-lighten5);
  display: flex;
  justify-content: space-between;
}
</style>
